import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-mp-toggle',
  templateUrl: './mp-toggle.component.html',
  imports: [TranslateModule, NgIf, FormsModule],
  styleUrl: './mp-toggle.component.scss'
})
export class MpToggleComponent {
  @Input() public label: string;
  @Input() public toggleState: boolean;
  @Input() public disabled: boolean = false;

  @Output() public toggleStateChange = new EventEmitter<boolean>();

  public modeSwitch(value: boolean) {
    if (this.disabled) {
      return;
    }

    this.toggleState = value;
    this.toggleStateChange.emit(value);
  }
}
